import React from "react";

import { Stack } from "@mui/material";

import { debounce } from "../../../helpers";
import { Dropdown, SearchInput } from "../../../components";

export default function ({ state, setState }) {
    const sortFilters = [{ id: 1, name: 'Most Recent' }, { id: 2, name: 'Most Donated' }];
    const handleSearchChange = e => {
        setState({
            ...state,
            offset: 0,
            searchString: e.target.value
        })
    }

    const handleSearch = React.useCallback(debounce(handleSearchChange, 500), []);

    return <Stack spacing={{ xs: 1, md: 4, sm: 2 }} direction={{ xs: 'column', sm: 'row', md: 'row' }} justifyContent="space-between">
        <SearchInput
            id="searchString"
            name="searchString"
            placeholder="Search By Transaction ID"
            size="small"
            onChange={handleSearch}
            fullWidth
        />
        <Dropdown
            id="sortBy"
            name="sortBy"
            label="Sort list"
            size="small"
            value={state.sortBy}
            onChange={e => setState({ ...state, sortBy: e.target.value })}
            options={sortFilters}
        />
    </Stack>
}